import Router from './app/app-routes';

Router.beforeEach((to, from, next) => {
  if (from.name) {
    if (to.name === 'success') {
      if (from.name !== 'transaction') {
        next({ name: 'Profile' })
        return
      }
    } else if (to.name === 'points') {
      if (from.name !== 'managers' && from.name !== 'transaction') {
        next({ name: 'Profile' })
        return
      }
    } else if (to.name === 'transaction') {
      if (from.name !== 'points') {
        next({ name: 'Profile' })
        return
      }
    } else if (to.name === 'managers') {
      if (from.name !== 'stores' && from.name !== 'points') {
        next({ name: 'Profile' })
        return
      }
    }
  } else {
    if (to.name !== 'Profile' && to.name !== 'login') {
      return next({ name: 'Profile' })
    }
  }
  next()
})

export default Router;